import {useDispatch, useSelector} from "react-redux";
import { useState, useEffect } from 'react';

import { clearLiveRegionText } from '../../../actions/app';

let timeoutToken = null;

const AriaLiveRegion = (props) => {
  const liveRegion = useSelector((state) => state.app.liveRegion);

  const dispatch = useDispatch();

  const [liveRegionValue, setLiveRegionValue] = useState([]);

  useEffect(() => {
    clearTimeout(timeoutToken);

    timeoutToken = setTimeout(() => {
      if (liveRegion.length) {
        setLiveRegionValue(liveRegion.join('. '));
        dispatch(clearLiveRegionText());
      }
    }, 500);

  }, [liveRegion,dispatch]);

  return (
    <div className="sr-hide" aria-live="polite" aria-atomic>{liveRegionValue}</div>
  );
};

export default AriaLiveRegion;